import React from 'react';
import Modal, { ModalCloseButton } from '../../shared/modals/Modal';

const VerifyModal = ({setVisible}) => {
  const closeModal = () => setVisible(false);

  return (
    <Modal isOpen={true} onClose={closeModal}>
      <div className="modal">
        <div className='modal__header'>
          <h3 className='margin-none'>Verify your email address</h3>
          <ModalCloseButton
            onClick={closeModal}
            label="Close verify email modal"
          />
        </div>

        <div className="modal__body">
          <p>
            Please check your email inbox for instructions on how to verify your email address and activate your Polygraph account.
          </p>
        </div>

        <div className='modal__footer'>
          <button className='btn primary'
                  onClick={closeModal}>
            OK
          </button>
        </div>

      </div>
    </Modal>
  );
}

export default VerifyModal;
